import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LDFlag } from '@core/models/user-profile.model';
import { UserStoreService } from '@core/services/user-store/user-store.service';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LegacyDefectReportsRedirectGuard implements CanActivate {
  constructor(
    private userService: UserStoreService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.userService.isAuthenticated$.pipe(
      filter((isAuthenticated) => isAuthenticated),
      take(1),
      map(() => {
        const canAccessLegacyDefectReports = !this.userService.getLDFlagValue(LDFlag.DEFECT_REPORTS_NEW);

        if (canAccessLegacyDefectReports) {
          return true;
        }

        return this.getLegacyToNewRedirect(route);
      })
    );
  }

  private getLegacyToNewRedirect(route: ActivatedRouteSnapshot): UrlTree {
    const childRoute = route.firstChild;
    const childPath = childRoute?.routeConfig?.path;

    if (childPath === 'create/:equipmentRef') {
      const equipmentRef = childRoute.paramMap.get('equipmentRef');

      if (!equipmentRef) {
        return this.router.createUrlTree(['/defects', 'new']);
      }

      return this.router.createUrlTree(['/defects', 'new'], {
        queryParams: { createForEquipment: equipmentRef }
      });
    }

    const defectRef =
      childPath === 'update/:ref'
        ? childRoute.paramMap.get('ref')
        : childRoute?.firstChild?.routeConfig?.path === ':ref'
          ? childRoute.firstChild.paramMap.get('ref')
          : null;

    if (defectRef) {
      return this.router.createUrlTree(['/defects', 'new'], {
        queryParams: { defectRef }
      });
    }

    return this.router.createUrlTree(['/defects', 'new']);
  }
}
